import AxiosInstance from "./api";

export const LoanDetailLedgerService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/loan-detail-ledgers/paginate", {
      params: query,
    });
  },

  getById: async (id) => {
    return await AxiosInstance.get("/private/loan-detail-ledgers/" + id);
  },

  create: async (payload) => {
    return await AxiosInstance.post("/private/loan-detail-ledgers", payload);
  },

  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/loan-detail-ledgers/" + id, payload);
  },

  delete: async (id) => {
    return await AxiosInstance.delete("/private/loan-detail-ledgers/" + id);
  },
};
